import React from 'react';
import './styles.css';
import { Button } from 'antd';
import { Device } from '../../../../../types/Device';
import { ReactComponent as SvgClose } from 'utils/app/assets/icons/Close.svg';

interface RecordingBarProps {
    device: Device;
    recordingType: 'audio' | 'video' | 'photo';
    onStop: () => void;
}

const RecordingBar: React.FC<RecordingBarProps> = ({ device, recordingType, onStop }) => {
    return (
        <div className="recording-timers">
            <div key={recordingType} className="recording-timer recording-timer-device">
                <div className={'recording-timer-container'}>
                    <span className={'headline small'} style={{ color: 'var(--gray-white)' }}>
                        {recordingType === 'audio' ? 'Идёт запись аудио' : 'Идёт запись видео'}
                    </span>
                </div>
                <Button
                    className={
                        'button-base button-type-primary button-size-large button-state-danger'
                    }
                    onClick={() => onStop()}
                >
                    <SvgClose
                        style={{ fill: 'var(--gray-white)', position: 'relative', top: -1 }}
                    />
                    Завершить
                </Button>
            </div>
        </div>
    );
};

export default RecordingBar;
